var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCancel = function SvgCancel(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#FA6060",
    d: "M15.73 1.955c7.617 0 13.774 6.158 13.774 13.776s-6.157 13.774-13.775 13.774c-7.617 0-13.775-6.157-13.775-13.774 0-7.618 6.158-13.776 13.776-13.776m0 11.833-4.946-4.945-1.942 1.942 4.945 4.945-4.945 4.946 1.942 1.942 4.945-4.945 4.946 4.945 1.942-1.942-4.945-4.945 4.945-4.946-1.942-1.942z"
  })));
};
export default SvgCancel;